<div class="container panelEditGeofences" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches), 'panelEditGeofences-FullSize': selectedTabIndex == 0}">
  <div class="mobile-handle" *ngIf="!mobileQuery.matches" (click)="fullScreen = !fullScreen">
    <mat-icon *ngIf="!fullScreen">keyboard_arrow_up</mat-icon>
    <mat-icon *ngIf="fullScreen">keyboard_arrow_down</mat-icon>
  </div>
  <loading [isLoading]="isLoading"></loading>

  <div class="header_panel">
    <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar" matTooltipPosition="above"><mat-icon>arrow_back_ios</mat-icon></a>
    <label *ngIf="$guidEditable == ''" class="titlePanel">Agregar Nueva Geocerca</label>
    <label *ngIf="$guidEditable != ''" class="titlePanel">Editar Geocerca</label>
  </div>

  <!-- detalles de geocerca -->
  <!-- <div class="details-section">
    <div class="row">
      <div class="section-header-background">
        <h3>Detalle de Geocerca</h3>
      </div>
    </div>

    <div class="row custom-input-container width-input">
      <mat-form-field class="">
        <input
          id="searchBtn"
          type="text"
          matInput
          placeholder="Nombre de Geocerca"
          required
          [(ngModel)]="fullRequest.name"
        />
      </mat-form-field>
    </div>
  </div> -->

  <!-- Tabs -->
  <div class="edit-geofences-tab-group">
    <div class="steps-container">
      <div class="step-line"></div>
      <div class="step-circle" [class.active]="selectedTabIndex >= 0" [class.current]="selectedTabIndex === 0" (click)="selectedTabIndex = 0">
        <span>1</span>
      </div>
      <div class="step-circle" [class.active]="selectedTabIndex >= 1" [class.current]="selectedTabIndex === 1" (click)="selectedTabIndex = 1">
        <span>2</span>
      </div>
      <div class="step-circle" [class.active]="selectedTabIndex >= 2" [class.current]="selectedTabIndex === 2" (click)="selectedTabIndex = 2">
        <span>3</span>
      </div>
      <div class="step-circle" [class.active]="selectedTabIndex >= 3" [class.current]="selectedTabIndex === 3" (click)="selectedTabIndex = 3">
        <span>4</span>
      </div>
    </div>
    <mat-tab-group style="height: 100%;" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)" id="panelAddGeofenceTabContent" [preserveContent]="true" [disablePagination]="true">

      <!-- primer tab -->
      <mat-tab >
        
        
        <ng-template mat-tab-label >
          <label id="addGeofenceIdentifiersTab"> <mat-icon class="example-tab-icon">directions_car</mat-icon> Identificadores </label>
        </ng-template>
        <ng-template matTabContent >
            <!-- Identificadores -->
            <div class="actives addGeofenceIdentifiersTabContent">
              
              <label class="first-step-titlePanel">Crear Geocerca</label>
              <div class="row custom-input-container width-input">
                <mat-form-field class="">
                  <input
                    id="searchBtn"
                    type="text"
                    matInput
                    placeholder="Nombre de Geocerca"
                    required
                    [(ngModel)]="fullRequest.name"
                  />
                </mat-form-field>
              </div>

              <label class="identifiers-title">Identificadores asociados</label>

              <div class="row center-item custom-input-container addGeofenceIdentifiersTabContent" id="addGeofenceIdentifiersSearcher">
                <mat-form-field>
                  <input
                    type="text"
                    matInput
                    placeholder="Vin o contrato"
                    [(ngModel)]="vehiculoInput"
                    required
                    name="vehiculoInput"
                    [matAutocomplete]="auto"
                    (click)="selectVehicule()"
                    (input)="onFindVehicule($event)"
                    (keyup.enter)="this.AddActive()"
                    required
                  />
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptionsVehicules | async" (click)="selectOption(option)" [value]="option">{{ option }}</mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <label class="error">* Solo se agregarán vines válidos y permitidos para el usuario</label>

              <div class="identifiers-buttons-container addGeofenceIdentifiersTabContent">
                <button class="btn-add-identifier" mat-raised-button (click)="AddActive()" matTooltip="Añadir VINS a la lista" matTooltipPosition="above">
                  Añadir
                </button>
                <button class="btn-remove-identifier" mat-raised-button (click)="removeAllActives()" matTooltip="Desasignar todos los VIN seleccionados" matTooltipPosition="right">
                  Eliminar Todos
                </button>
              </div>
  
              <div class="vin-filter-container" id="addGeofenceIdentifiersList">
                <div class="row vin-filter addGeofenceIdentifiersTabContent" *ngIf="fullRequest.identifiers.length > 0">
                  <div class="col-11 center-item custom-input-container">
                    <mat-form-field>
                      <input
                        #vehiculosFinderInput
                        type="text"
                        matInput
                        placeholder="Filtrar VIN en listado"
                        name="vehiculosFinder"
                        (input)="findFromVehiculeArray(vehiculosFinderInput.value)"
                      />
                    </mat-form-field>
                  </div>
                </div>
                
                <div class="identifier-list addGeofenceIdentifiersTabContent">
                  <div class="identifier-card" *ngFor="let item of fullRequest.identifiers">
                    <div class="identifier-card-content" (click)="onVinClick(item)">
                      <span class="identifier-card-title">{{ item }}</span>
                    </div>
                    <div class="identifier-card-delete" (click)="RemoveActive(item)">
                      <mat-icon>close</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
  
            <!-- contador de identificadores -->
            <div class="container actives-total addGeofenceIdentifiersTabContent">
              <div class="row text-instructions">
                <label>Total agregados {{ fullRequest.identifiers.length }}</label>
              </div>
            </div>
  
            <!-- <div class="container row mt-2 center-item addGeofenceIdentifiersTabContent">
              <div class="col-4">
                <button class="btnCancel" mat-raised-button (click)="CancelButton()">
                  Cancelar
                </button>
              </div>
              <div class="col-12">
                <button class="btnSave" mat-raised-button (click)="onSaveChanges()">
                  Guardar
                </button>
              </div>
            </div> -->
            
          </div>
        </ng-template>
      </mat-tab>
  
      <!-- segundo tab -->
      <mat-tab>
        <ng-template mat-tab-label >
          <label id="addGeofenceConfigTab"> <mat-icon class="example-tab-icon">category</mat-icon> Geometria </label>
        </ng-template>

        <ng-template matTabContent >
          <!-- Configuración de geocercas -->
          <div class="geometry-configuration addGeofenceConfigTabContent">
            <div class="row">
              <!-- <div class="section-header-background">
                <h3>Configuración de Geocerca:</h3>
              </div> -->
              <label class="first-step-titlePanel">Configuración de Geocerca</label>
            </div>

            <div class="status-container addGeofenceConfigTabContent" id="addGeofenceGeometryStatus">
              <div class="status-buttons">
                <button class="status-btn" [class.active]="fullRequest.status" (click)="fullRequest.status = true; toggleStatusCheckbox()">
                  <mat-icon class="status-icon">power_settings_new</mat-icon>
                  <span>On</span>
                </button>
                <button class="status-btn" [class.active]="!fullRequest.status" (click)="fullRequest.status = false; toggleStatusCheckbox()">
                  <mat-icon class="status-icon">power_settings_new</mat-icon>
                  <span>Off</span>
                </button>
              </div>
              <span class="status-label">Geocerca Activa</span>
            </div>

            <div class="selects-container addGeofenceConfigTabContent">
              <p class="select-title">Tipo de Geocerca</p>
              <div class="custom-select-container" id="addGeofenceGeofenceTypes">
                <mat-form-field class="custom-select" appearance="fill">
                  <mat-select [(ngModel)]="fullRequest.idGeofenceType" (selectionChange)="onChangeGeofenceType($event.value)">
                    <mat-option *ngFor="let item of listGeofenceTypes" [value]="StringToNumber(item.key)"> {{item.value}} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <p class="select-title">Categoría de Geocerca</p>
              <div class="custom-select-container" id="addGeofenceGeofenceCategories">
                <mat-form-field class="custom-select" appearance="fill">
                  <mat-select [(ngModel)]="fullRequest.idGeofenceCategory" (selectionChange)="onChangeGeofenceCategory($event.value)">
                    <mat-option *ngFor="let item of listGeofenceCategories" [value]="StringToNumber(item.key)"> {{item.value}} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
  
          </div>
            
  
         
      </ng-template>
      </mat-tab>

      <!-- tercer tab -->
      <mat-tab>
        <ng-template mat-tab-label >
          <label id="addGeofenceGeometryTab"> <mat-icon class="example-tab-icon">category</mat-icon> Geometria </label>
        </ng-template>
  
        <ng-template matTabContent >
          <!-- Configuración de geocercas -->
          <div class="geometry-configuration addGeofenceGeometryTabContent">
  
            <div class="geometry-type-section addGeofenceGeometryTabContent" id="addGeofenceGeometryType">
                <p class="text-subtitle"><strong>Tipo de Geometria</strong></p>
                <div class="geometry-button-group">
                  <button [ngClass]="{'btnPin-selected': fullRequest.idGeometryType == EnumGeometryTypes.Buffer}" class="geometry-btn geometry-btn-left" (click)="selectGeometry(EnumGeometryTypes.Buffer)" matTooltip="Herramienta de selección de punto activo" matTooltipPosition="below" id="addGeofenceGeometryTypeBuffer">
                    <mat-icon class="geometry-icon">arrow_drop_down_circle</mat-icon>
                    <span class="geometry-label">Circulo</span>
                  </button>
                  <button [ngClass]="{'btnPin-selected': fullRequest.idGeometryType == EnumGeometryTypes.Polygon}" class="geometry-btn geometry-btn-middle" (click)="selectGeometry(EnumGeometryTypes.Polygon)" matTooltip="Herramienta de selección de puntos" matTooltipPosition="below" id="addGeofenceGeometryTypePolygon">
                    <mat-icon class="geometry-icon">crop_square</mat-icon>
                    <span class="geometry-label">Poligono</span>
                  </button>
                  <button [ngClass]="{'btnPin-selected': fullRequest.idGeometryType == EnumGeometryTypes.Zone}" class="geometry-btn geometry-btn-right" (click)="selectGeometry(EnumGeometryTypes.Zone)" matTooltip="Zonas predefinidas" matTooltipPosition="below" id="addGeofenceGeometryTypeZone">
                    <mat-icon class="geometry-icon">map</mat-icon>
                    <span class="geometry-label">E. Federativa</span>
                  </button>
                </div>
            </div>

             <!-- manejador de la geometria -->
            <div class="container addGeofenceGeometryTabContent">
              <!-- Manejador del buffer -->
              <div *ngIf="fullRequest.idGeometryType == EnumGeometryTypes.Buffer" class="row geometry-container">
                <p class="text-subtitle"><strong>Define la geometria de la geocerca</strong></p>
                <!-- <p *ngIf="this.mobileQuery.matches"  class="text-instructions">
                  Cuando estés listo, haz click en el <strong>Botón Definir Punto Activo </strong> para activar la 
                  herramienta de circunferencia y haz click sobre el mapa en el lugar donde quieras que 
                  sea el centro de la Geocerca. Si te equivocas no importa, puedes definir el punto activo 
                  cuantas veces lo desees oprimiendo el botón nuevamente.
                </p> -->
                <buffer-selector
                  [fullScreen]="fullScreen"
                  [initialRadio]="initialRadio"
                  (changedRadio)="onChangeRadio($event)"
                ></buffer-selector>
                <!-- <div class="row center-item">
                  <div class="col-12">
                    <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="bufferButtonMsg" [isVisible]="isBufferButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
                    <button [ngClass]="{'btnPin-polygon': mapHelperService.AddBufferGeofenceMode}" class="btnPin" mat-raised-button (click)="onSetBufferCenter(); this.fullScreen = false;">
                      <p class="color-white center-item"><mat-icon class="example-tab-icon">control_point</mat-icon> Definir Punto Activo</p>
                    </button>
                  </div>
                </div>
                <div class="row center-item">   
                    <div class="text-center" [hidden]="!isVisibleControlSliderRadio">
                      <h3>Radio Km</h3>
                    </div>
                    <mat-slider
                      [hidden]="!isVisibleControlSliderRadio"
                      thumbLabel
                      name="radioSelector"
                      [displayWith]="formatLabel"
                      step="0.2"
                      [min]="initialRadio"
                      max="5"
                      aria-label="kilometros"
                      showTickMarks 
                      discrete 
                      class="cdk-focused"
                      (change)="onChangeRadio(inputSlider)">
                      <input matSliderThumb [(ngModel)]="mapHelperService.radioKm" #inputSlider>
                    </mat-slider>
                </div> -->
              </div>
    
              <!-- Manejador del poligono -->
              <div *ngIf="fullRequest.idGeometryType == EnumGeometryTypes.Polygon" class="row geometry-container">
                <p class="text-subtitle"><strong>Poligono</strong></p>
                <!-- <p *ngIf="this.mobileQuery.matches"  class="text-instructions">Al presionar "Seleccionar vertices", seleccione los puntos en el mapa que serán los vertices del poligono, debe seleccionar por lo menos 3, al terminar presione click derecho para detener la herramienta</p> -->
                <geofence-polygon-creator></geofence-polygon-creator>
                <!-- <div class="row center-item">
                  <div class="col-12">
                    <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonButtonMsg" [isVisible]="isPolygonButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
                    <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container-top" [Mensaje]="polygonFinishMsg" [isVisible]="fullRequest.idGeometryType == EnumGeometryTypes.Polygon && !isPolygonButtonMsgVisible"></app-tooltip>
                    <button  [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'create'}" class="btnPin" mat-raised-button (click)="createPolygonPoints(); this.fullScreen = false;" >
                      <p class="color-white center-item"><mat-icon class="example-tab-icon">control_point</mat-icon>  Seleccionar Vertices</p>
                    </button>
                  </div>
                </div>

                <div class="row center-item">
                  <div class="col-6">
                    <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonEditButtonMsg" [isVisible]="isPolygonEditButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
                    <button [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'edit'}" class="btnPin" mat-raised-button (click)="editPolygonPoints()">
                      <p class="color-white center-item"><mat-icon class="example-tab-icon">edit</mat-icon>  Editar</p>
                    </button>
                  </div>
                  <div class="col-6">
                    <button class="btnPin" mat-raised-button (click)="deletePolygonPoints()" matTooltip="Herramienta de borrado de poligono" matTooltipPosition="right">
                      <p class="color-white center-item"><mat-icon class="example-tab-icon">delete</mat-icon>  Borrar</p>
                    </button>
                  </div>
                </div> -->
                
              </div>

              <!-- Manejador de selector de zonas -->
              <div *ngIf="fullRequest.idGeometryType == EnumGeometryTypes.Zone" class="row geometry-container">
                <p class="text-subtitle"><strong>Selecciona la zona de la geocerca</strong></p>
                <!-- <p *ngIf="this.mobileQuery.matches"  class="text-instructions">Selecciona el nivel y las zonas en el mapa que deseas incluir en la geocerca.</p> -->
                <zone-selector></zone-selector>
              </div>

            </div>
    
            <div class="container row mt-2 center-item mt-5 addGeofenceGeometryTabContent">
              <!-- <div class="col-4">
                <button class="btnCancel" mat-raised-button (click)="CancelButton()">
                  Cancelar
                </button>
              </div> -->
              <!-- <div class="col-12" id="addGeofenceSaveButton">
                <button class="btnSave" mat-raised-button (click)="onSaveChanges()">
                  Guardar
                </button>
              </div> -->
            </div>
          </div>
            
  
         
      </ng-template>
      </mat-tab>
  
      <!-- cuarto tab -->
      <mat-tab>
        <ng-template mat-tab-label >
          <label id="addGeofenceFrecuencyTab"> <mat-icon class="example-tab-icon">alarm</mat-icon> Monitoreo </label>
        </ng-template>
  
        <ng-template matTabContent>
          <div class="monitoring-configuration">
            
            <p class="text-subtitle"><strong>Monitoreo de geocerca</strong></p>
            <!-- <div class="row row-data">
                <p class="text-subtitle"><strong>Tipo de Monitoreo</strong></p>
                <div class="col-6">
                  <button [ngClass]="{'btnPin-selected': fullRequest.alarmType == 'full'}" class="btnPin" mat-raised-button (click)="selectMonitoring('full')" matTooltip="Monitoreo de 24 Hrs" matTooltipPosition="above">
                    <p class="btn-text">24 Hrs</p>
                  </button>
                </div>
                <div class="col-6">
                  para el futuro (click)="selectMonitoring('personalized')" 
                  <button [ngClass]="{'btnPin-selected': fullRequest.alarmType == 'personalized'}" class="btnPin" mat-raised-button matTooltip="proximamente" matTooltipPosition="right">
                    <p class="btn-text">Personalizado</p>
                  </button>
                </div>
            </div> -->
            <!-- Selector de recurrencia de monitoreo -->
            <div *ngIf="fullRequest.alarmType == 'personalized'" class="">
              <div class="row row-data">
                <p class="text-subtitle"><strong>Recurrencia</strong></p>
                <div class="col-6">
                  <button [ngClass]="{'btnPin-selected': fullRequest.alarmFrecuency == 'individual'}" class="btnPin" mat-raised-button (click)="selectFrecuency('individual')" matTooltip="Cada dia seleccionado sonará una alarma" matTooltipPosition="above">
                    <p class="btn-text">Dias individuales</p>
                  </button>
                </div>
                <div class="col-6">
                  <button [ngClass]="{'btnPin-selected': fullRequest.alarmFrecuency == 'range'}" class="btnPin" mat-raised-button (click)="selectFrecuency('range')" matTooltip="La alarma durará por un rango de días" matTooltipPosition="above">
                    <p class="btn-text">Rango de días</p>
                  </button>
                </div>
              </div>
    
              <!-- Manejador de la fecha individual -->
              <div *ngIf="fullRequest.alarmFrecuency == 'individual'" class="row geometry-container">
                <p class="text-instructions"><strong>Día</strong></p>
                <div class="row center-item">
                  <div class="col-6">
                    <div class="days-selection">
                      <label *ngFor="let day of days" class="day-checkbox">
                        <input type="checkbox" [(ngModel)]="day.selected">
                        <span [ngClass]="{ 'selected': day.selected }">{{ day.initial }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">   
                  <div class="col-6">
                    <label>Inicio:</label>
                    <mat-form-field>
                      <input matInput [ngxTimepicker]="horaPicker" [(ngModel)]="horaInicio" placeholder="Seleccione una hora">
                      <mat-icon matSuffix>access_time</mat-icon>
                      <ngx-material-timepicker #horaPicker></ngx-material-timepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <label>Fin:</label>
                    <mat-form-field>
                      <input matInput [ngxTimepicker]="horaPicker2" [(ngModel)]="horaFin" [min]="horaInicio" placeholder="Seleccione una hora">
                      <mat-icon matSuffix>access_time</mat-icon>
                      <ngx-material-timepicker #horaPicker2></ngx-material-timepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
    
              <!-- Manejador de fecha por rango -->
              <div *ngIf="fullRequest.alarmFrecuency == 'range'" class="row">
                <div class="row center-item">
                  <p class="text-subtitle"><strong>Día Inicial</strong></p>
                  <div class="col-6">
                    <div class="days-selection">
                      <label *ngFor="let day of days" class="day-checkbox">
                        <input type="radio" name="diaInicial" [(ngModel)]="diaInicial" (ngModelChange)="calcularRango()" [value]="day">
                        <span [ngClass]="{ 'selected': day.selected }">{{ day.initial }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="days-selection">
                      <label>Hora:</label>
                      <mat-form-field>
                        <input matInput [ngxTimepicker]="horaPicker" [(ngModel)]="horaInicio" (ngModelChange)="calcularRango()" placeholder="Seleccione una hora">
                        <mat-icon matSuffix>access_time</mat-icon>
                        <ngx-material-timepicker #horaPicker></ngx-material-timepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row center-item">
                  <p class="text-subtitle"><strong>Día Final</strong></p>
                  <div class="col-6">
                    <div class="days-selection">
                      <label *ngFor="let day of days" class="day-checkbox">
                        <input type="radio" name="diaFinal" [(ngModel)]="diaFinal" (ngModelChange)="calcularRango()" [value]="day">
                        <span [ngClass]="{ 'selected': day.selected }">{{ day.initial }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="days-selection">
                      <label>Hora:</label>
                      <mat-form-field>
                        <input matInput [ngxTimepicker]="horaPicker2" [(ngModel)]="horaFin" (ngModelChange)="calcularRango()" placeholder="Seleccione una hora">
                        <mat-icon matSuffix>access_time</mat-icon>
                        <ngx-material-timepicker #horaPicker2></ngx-material-timepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row center-item">
                  <p class="text-instructions" *ngIf="rangoCalculado">El rango seleccionado es {{ rangoCalculado }}</p>
                </div>
              </div>
            </div>
            <!-- correo de aviso -->
            <div class="container row center-item mail-container">
              <label for="email">Correo Electrónico:</label>
              <textarea id="email" name="email" [(ngModel)]="fullRequest.emailAlert"></textarea>
    
            </div>

            
            <p class="error"> *Puedes ingresar varios correos separándolos por un punto y coma (;)</p>
    
            <div class="container row mt-2 center-item">
              <!-- <div class="col-4">
                <button class="btnCancel" mat-raised-button (click)="CancelButton()">
                  Cancelar
                </button>
              </div> -->
              <div class="col-12">
                <button class="btnSave" mat-raised-button (click)="onSaveChanges()">
                  Guardar
                </button>
              </div>
            </div>
          </div>
  
          
        </ng-template>
      </mat-tab>
  
    </mat-tab-group>
  </div>

  <!-- flechas de navegacion -->
  <!-- <div class="container nav-arrow mt-2">
    <a class="btn-img" [style.visibility]="selectedTabIndex > 0 ? 'visible' : 'hidden'" (click)="selectTabButton('prev')" matTooltip="Previo" matTooltipPosition="above">
      <mat-icon style="padding-left: 5px;" aria-hidden="false" aria-label="">arrow_back_ios</mat-icon>
    </a>
    <a class="btn-img" [style.visibility]="selectedTabIndex < 2 ? 'visible' : 'hidden'" (click)="selectTabButton('next')" matTooltip="Siguiente" matTooltipPosition="above">
      <mat-icon aria-hidden="false" aria-label="">arrow_forward_ios</mat-icon>
    </a>
  </div>
  <div class="row">
    <div class="section-footer-background">
    </div>
  </div> -->
</div>
